import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import { PsRoutes } from '../shared/routing/Routes';
import { NotificationListScreen } from './notifications/list/NotificationListScreen';
import { MessageListScreen } from './messages/list/MessageListScreen';
import MessageDetailScreen from './messages/to-refactor/detail/MessageDetailScreen';

export class MessagesNotificationsRouting extends React.Component {

    render() {
        const { currentUser } = this.props;

        if ( currentUser.isSuperAdmin() ) {
            return null;
        }

        return (
            <React.Fragment>
                <Route path={PsRoutes.NOTIFICATIONS} exact component={NotificationListScreen}/>
                <Route path={PsRoutes.MESSAGES} exact component={MessageListScreen}/>
                <Route path={PsRoutes.MESSAGES_DETAIL} exact component={MessageDetailScreen}/>
            </React.Fragment>
        );
    }
}

MessagesNotificationsRouting.propTypes = {
    currentUser: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/app/messages-notifications/MessagesNotificationsRouting.jsx